import React, { useEffect, useContext, useState, useRef, useCallback } from "react";
import { CanvasContext } from "../contexts/CanvasContext";
import { TreeItem } from '@mui/x-tree-view/TreeItem';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import { SimpleTreeView } from "@mui/x-tree-view/SimpleTreeView";
import { Button, Stack, Typography, Paper, Modal, Tooltip, Grid, Box, TextField, IconButton, useMediaQuery, useTheme } from '@mui/material';
import anime from "animejs";
import '../styles/canvas.css';
import InfoIcon from '@mui/icons-material/Info';
import CloseIcon from '@mui/icons-material/Close';
import AutoFixHighIcon from '@mui/icons-material/AutoFixHigh';


import {
  PlayArrow, Create,
  Delete,

} from '@mui/icons-material';


export default function ExplorationTree() {
  const {
    layoutType,
    animationRef,
    layers, setLayers,
    fetchData, API_URL, animationBlocks, setAnimationBlocks,
    groups, setGroups,
    generateAnimation,
    generateGroups,
    setSelectedSegments,
    setAnimationScript,
    setElementOffsets,
    setSelectedAnimation,
    setOverlayMessage,
    setIsPlayingAnimation,
    setConcept,
    isSelected, treeData, jsonData, captureScreenshots, setElementOffsetsBackend, executeAnimation,
  } = useContext(CanvasContext);

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const resetCanvasElementsForReplay = async () => {
    layers.forEach(layer => {
      const element = document.getElementById(layer.id);
      if (element) {
        // Reset specific animated properties
        element.style.transform = ''; // Reset transform properties
        element.style.boxShadow = ''; // Reset box-shadow properties
        element.style.opacity = ''; // Reset opacity properties (if animated)
        element.style.transition = ''; // Reset transition properties (if animated)
        element.style.animation = ''; // Reset animation properties (if animated)

      }
    });

    setLayers([...layers]);
  }

  const startAnimation = async (filename, successful_run) => {
    setElementOffsets({});
    setConcept([]);
    resetCanvasElementsForReplay();
    const userId = localStorage.getItem('userId');

    const scriptResponse = await fetch(`${API_URL}/load_animation_file_firebase`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ filename: filename, successful_run: successful_run, userId: userId }),
    });
    const scriptData = await scriptResponse.json();

    setAnimationScript(scriptData.logo_animation);
    setConcept(scriptData.concept);
    console.log("concept", scriptData.concept);
    setAnimationBlocks(scriptData.segments);
    console.log("animationBlocks", scriptData.segments);

    if (scriptData.element_offsets) {

      setElementOffsets(scriptData.element_offsets);

    }

    await executeAnimation(anime, scriptData.logo_animation, filename);

    if (animationRef.current) {
      animationRef.current.play();
    }
  }


  const handleEditClick = (currentPath, successful_run) => {
    handleOptionSelected(currentPath, successful_run);

  };




  useEffect(() => {
    fetchData();
  }, []);

  const handleOptionSelected = async (fileName, successful_run) => {

    setSelectedAnimation(fileName);
    setSelectedSegments([]);

    const script = await loadAnimationData(fileName, successful_run);


  };

  const loadAnimationData = async (filename, successful_run) => {
    const userId = localStorage.getItem('userId');

    try {
      const response = await fetch(`${API_URL}/load_animation_file_firebase`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ filename: filename, successful_run, userId: userId }),
      });
      const data = await response.json();

      setLayers(data.layers);
      generateGroups(data.layers);
      setAnimationScript(data.logo_animation);
      setConcept(data.concept);
      setElementOffsets(data.element_offsets);
      setAnimationBlocks(data.segments);

      return data.logo_animation;
    } catch (error) {
      console.error('Failed to load animation data:', error);
      return null;
    }
  };

  const handleDeleteOption = async (fileName) => {
    const userId = localStorage.getItem('userId');

    fileName = 'variations/' + userId + "/" + fileName;


    try {
      const response = await fetch(`${API_URL}/delete_animation`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ fileName, userId }),
      });
      if (response.ok) {

        fetchData();

      } else {
        console.error('Failed to delete animation');
      }
    } catch (error) {
      console.error('Failed to delete animation:', error);
    }
  };

  const FileTreeView = ({ treeData, fetchData }) => {

    const renderTree = (nodes, path = '', isTopLevel = true) => (
      Object.keys(nodes).map(key => {
        const currentPath = path ? `${path}/${key}` : key;

        if (isTopLevel && !currentPath.startsWith(layoutType)) {
          return null;
        }

        if (key.endsWith('.json')) {
          return (
            <TreeItem key={currentPath} itemId={currentPath} sx={{ textAlign: "left", border: 'solid 1px black', backgroundColor: isSelected(`variations/${currentPath}`) ? '#e2d5f2' : 'transparent' }} label={
              <Stack direction="row" key={key} onClick={() => handleOptionSelected(`variations/${currentPath}`, jsonData[currentPath]?.successful_run)}>


                <Button
                  type="button"
                  variant="outlined"
                  sx={{
                    flex: 1,
                    height: '100%',
                    border: "none",
                    textAlign: "left !important",
                    color: 'black',
                    '&:hover': {
                      border: 'none' // Define the border style on hover
                    }
                  }}
                >
                  {jsonData[currentPath]?.title}
                </Button>


                <div style={{ visibility: isSelected(`variations/${currentPath}`) ? 'visible' : 'hidden' }}>
                  <Button variant="outlined" sx={{ height: '100%', margin: "0" }} color="primary" onClick={() => startAnimation(`variations/${currentPath}`, jsonData[currentPath]?.successful_run)}>
                    <PlayArrow />
                  </Button>

                  <Button variant="outlined" sx={{ height: '100%' }} color="secondary" onClick={() => handleDeleteOption(`${currentPath}`)}>
                    <Delete />
                  </Button>
                </div>

              </Stack>

            } />
          );
        }

        return (
          <div key={currentPath} className="tree-node-container">
            <div className="tree-node-border"></div>
            {nodes[key] ? renderTree(nodes[key], currentPath, false) : null}
          </div>
        );
      })
    );
    const [modalOpen, setModalOpen] = useState(false);

    const handleOpenModal = () => setModalOpen(true);
    const handleCloseModal = () => setModalOpen(false);
    return (
      <SimpleTreeView
        id="exploration-tree"
        aria-label="file system navigator"
        defaultCollapseIcon={<ExpandMoreIcon />}
        defaultExpandIcon={<ChevronRightIcon />}
        sx={{
          minHeight: '50vh', // Set a minimum height
          height: '100%',
          width: '100%',
          display: 'flex',
          flexDirection: 'column'
        }}
      >
        <Box sx={{ display: 'flex', alignItems: 'center', mb: 3, }}>
          <Typography variant="h5" sx={{ mr: 1 }}>
            History
          </Typography>
          {/* <Tooltip
            title={<Typography sx={{ fontSize: '0.7rem' }}>Click to Learn More</Typography>}
            arrow>
            <InfoIcon
              onClick={handleOpenModal}
              // title="Click for more information"
              sx={{
                cursor: 'pointer',
                fontSize: isMobile ? '0.80rem' : '1rem', // Adjust values as needed
              }}
            />
          </Tooltip> */}
        </Box>

        {/* Modal */}
        <Modal
          open={modalOpen}
          onClose={handleCloseModal}
          aria-labelledby="info-modal-title"
        >
          <Paper
            sx={{
              position: 'absolute',
              top: '50%',
              left: '50%',
              transform: 'translate(-50%, -50%)',
              width: { xs: '90%', sm: 400 },
              p: 3,
              outline: 'none',
              maxWidth: 500,
              maxHeight: '90vh',
              overflow: 'auto'
            }}
          >
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
              <Typography id="info-modal-title" variant="h6">
                Exploration Tree Information
              </Typography>
              <IconButton size="small" onClick={handleCloseModal}>
                <CloseIcon />
              </IconButton>
            </Box>

            <Typography component="ul" sx={{ mb: 2, pl: 2 }}>
              <Typography component="li" sx={{ mb: 1 }}>
                Choose one of the four LogoMotion's automatic animations and play it.
              </Typography>
              <Typography component="li" sx={{ mb: 1 }}>
                Now, you can view the layers and the narrative timeline of the animation.
              </Typography>
              <Typography component="li" sx={{ mb: 1 }}>
                Start Editing!
              </Typography>
              <Typography component="li" sx={{ mb: 1 }}>
                Each edit made becomes a new node on the Exploration Tree.
              </Typography>
            </Typography>


            <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
              <Button onClick={handleCloseModal}>Close</Button>
            </Box>
          </Paper>
        </Modal>

        {renderTree(treeData)}

        {/* History Footer with Generate Button */}
        <Box sx={{ 
          mt: 2, 
          pt: 2, 
          borderTop: '1px solid #e0e0e0',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center'
        }}>
          <Typography 
            variant="caption" 
            sx={{ 
              mb: 1, 
              color: 'text.secondary',
              fontWeight: 500,
              textTransform: 'uppercase',
              letterSpacing: '0.5px'
            }}
          >
            Create New Animation
          </Typography>
          <Button
            variant="outlined"
            onClick={generateAnimation}
            size={isMobile ? "small" : "medium"}
            sx={{
              borderStyle: 'dashed',
              borderColor: 'primary.main',
              color: 'primary.main',
              backgroundColor: 'transparent',
              '&:hover': {
                backgroundColor: 'primary.main',
                color: 'white',
                borderStyle: 'solid'
              },
              minWidth: '140px'
            }}
          >
            <AutoFixHighIcon sx={{ mr: 1 }} /> Generate
          </Button>
        </Box>

      </SimpleTreeView>
    );
  }

  return (
    <div id="exploration_tree">
      <Stack direction="column" className="exploration-tree-stack">
        <FileTreeView treeData={treeData} fetchData={fetchData} />
      </Stack>
    </div>


  )
}
